import { render, staticRenderFns } from "./TodayChecklist.vue?vue&type=template&id=8bcfbcaa&scoped=true&"
import script from "./TodayChecklist.vue?vue&type=script&lang=js&"
export * from "./TodayChecklist.vue?vue&type=script&lang=js&"
import style0 from "./TodayChecklist.vue?vue&type=style&index=0&id=8bcfbcaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcfbcaa",
  null
  
)

export default component.exports